// // src/App.js
// import React, { useLayoutEffect, useState, useEffect } from "react";
// import {
//   BrowserRouter,
//   Routes,
//   Route,
//   Navigate,
//   useLocation,
//   useParams,
// } from "react-router-dom";
// import axios from "axios";

// import "./styles/base.css";

// import Navbar from "./components/Navbar";
// import Footer from "./components/Footer";
// import HelplineWidget from "./components/HelplineWidget";

// /* ---------- Pages ---------- */
// import Home from "./pages/Home";
// import About from "./pages/About";
// import Fees from "./pages/Fees";
// import Courses from "./pages/Courses";
// import Register from "./pages/Register";
// import Test from "./pages/Test";
// import PayNow from "./pages/PayNow";
// import CandidateLogin from "./pages/CandidateLogin";
// import CandidateDashboard from "./pages/CandidateDashboard";
// import AdminLogin from "./pages/AdminLogin";
// import AdminDashboard from "./pages/AdminDashboard";
// import SetPassword from "./pages/SetPassword";
// import CandidateBatches from "./pages/CandidateBatches";

// /* ---------- API BASE ---------- */

// const API_BASE =
//   (process.env.REACT_APP_API_URL || "http://localhost:5000").replace(/\/$/, "");

// axios.defaults.baseURL = API_BASE;

// /* ---------- Scroll Fix ---------- */

// function ScrollToTopOnRouteChange() {
//   const location = useLocation();

//   useLayoutEffect(() => {
//     if ("scrollRestoration" in window.history) {
//       window.history.scrollRestoration = "manual";
//     }
//     requestAnimationFrame(() => {
//       window.scrollTo(0, 0);
//     });
//   }, [location.pathname]);

//   return null;
// }

// /* ---------- Candidate Auth Guard ---------- */

// function ProtectedCandidateRoute({ children }) {
//   const token = localStorage.getItem("candidateToken");

//   if (!token) return <Navigate to="/candidate" replace />;

//   return children;
// }

// /* ---------- Test Access Guard (PAYMENT BASED) ---------- */

// function ProtectedTestRoute({ children, fallback = "/candidate/dashboard" }) {
//   const [state, setState] = useState({ loading: true, allowed: false });

//   useEffect(() => {
//     let mounted = true;

//     async function verify() {
//       const token = localStorage.getItem("candidateToken");

//       if (!token) {
//         if (mounted) setState({ loading: false, allowed: false });
//         return;
//       }

//       try {
//         const res = await axios.get("/api/candidate/home", {
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         const student = res.data?.student || {};
//         const paymentStatus = String(student.payment_status || "").toLowerCase();

//         const allowed =
//           paymentStatus.includes("paid") ||
//           paymentStatus.includes("success") ||
//           paymentStatus.includes("completed");

//         if (mounted) setState({ loading: false, allowed });
//       } catch (err) {
//         console.error("Test access check failed:", err);
//         if (mounted) setState({ loading: false, allowed: false });
//       }
//     }

//     verify();

//     return () => (mounted = false);
//   }, []);

//   if (state.loading) {
//     return <div style={{ padding: 20 }}>Checking test access...</div>;
//   }

//   if (!state.allowed) {
//     return <Navigate to={fallback} replace />;
//   }

//   return children;
// }

// /* ---------- Test Wrapper ---------- */

// function TestWrapper() {
//   const { id } = useParams();
//   return <Test testId={id} />;
// }

// /* ---------- MAIN APP ---------- */

// export default function App() {
//   const [adminToken, setAdminToken] = useState(() =>
//     localStorage.getItem("token")
//   );

//   const [candidateToken, setCandidateToken] = useState(() =>
//     localStorage.getItem("candidateToken")
//   );

//   return (
//     <BrowserRouter>
//       <ScrollToTopOnRouteChange />

//       <Navbar
//         token={adminToken}
//         onLogout={() => {
//           localStorage.removeItem("token");
//           setAdminToken(null);
//           window.location.href = "/admin";
//         }}
//         onCandidateLogout={() => {
//           localStorage.removeItem("candidateToken");
//           setCandidateToken(null);
//           window.location.href = "/candidate";
//         }}
//       />

//       <main className="content">
//         <Routes>

//           {/* ---------- Public Routes ---------- */}

//           <Route path="/" element={<Home />} />
//           <Route path="/home" element={<Home />} />
//           <Route path="/about" element={<About />} />
//           <Route path="/fees" element={<Fees />} />
//           <Route path="/courses" element={<Courses />} />
//           <Route path="/courses/:id" element={<Courses />} />
//           <Route path="/register" element={<Register />} />
//           <Route path="/pay" element={<PayNow />} />

//           {/* ---------- Candidate Login ---------- */}

//           <Route
//             path="/candidate"
//             element={<CandidateLogin onCandidateLogin={setCandidateToken} />}
//           />

//           {/* ---------- Candidate Dashboard ---------- */}

//           <Route
//             path="/candidate/dashboard"
//             element={
//               <ProtectedCandidateRoute>
//                 <CandidateDashboard />
//               </ProtectedCandidateRoute>
//             }
//           />

//           {/* ---------- Candidate Test (SECURED) ---------- */}

//           <Route
//             path="/candidate/test"
//             element={
//               <ProtectedCandidateRoute>
//                 <ProtectedTestRoute>
//                   <Test />
//                 </ProtectedTestRoute>
//               </ProtectedCandidateRoute>
//             }
//           />

//           {/* Optional direct test route */}
//           <Route
//             path="/test"
//             element={
//               <ProtectedCandidateRoute>
//                 <ProtectedTestRoute>
//                   <Test />
//                 </ProtectedTestRoute>
//               </ProtectedCandidateRoute>
//             }
//           />

//           <Route
//             path="/test/:id"
//             element={
//               <ProtectedCandidateRoute>
//                 <ProtectedTestRoute>
//                   <TestWrapper />
//                 </ProtectedTestRoute>
//               </ProtectedCandidateRoute>
//             }
//           />

//           {/* ---------- Candidate Batches ---------- */}

//           <Route
//             path="/candidate/batches"
//             element={
//               <ProtectedCandidateRoute>
//                 <ProtectedTestRoute>
//                   <CandidateBatches />
//                 </ProtectedTestRoute>
//               </ProtectedCandidateRoute>
//             }
//           />

//           {/* ---------- Admin ---------- */}

//           <Route
//             path="/admin"
//             element={
//               adminToken ? (
//                 <AdminDashboard token={adminToken} />
//               ) : (
//                 <AdminLogin setToken={setAdminToken} />
//               )
//             }
//           />

//           {/* ---------- Password ---------- */}

//           <Route path="/set-password" element={<SetPassword />} />

//           {/* ---------- Fallback ---------- */}

//           <Route path="*" element={<Navigate to="/" replace />} />

//         </Routes>
//       </main>

//       <HelplineWidget />
//       <Footer />
//     </BrowserRouter>
//   );
// }



// src/App.js
import React, { useLayoutEffect, useState, useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
  useParams,
} from "react-router-dom";

import "./styles/base.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HelplineWidget from "./components/HelplineWidget";

/* ---------- API ---------- */
import api from "./utils/api";

/* ---------- Pages ---------- */
import Home from "./pages/Home";
import About from "./pages/About";
import Fees from "./pages/Fees";
import Courses from "./pages/Courses";
import Register from "./pages/Register";
import Test from "./pages/Test";
import PayNow from "./pages/PayNow";
import CandidateLogin from "./pages/CandidateLogin";
import CandidateDashboard from "./pages/CandidateDashboard";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import SetPassword from "./pages/SetPassword";
import CandidateBatches from "./pages/CandidateBatches";

/* ---------- Scroll Fix ---------- */

function ScrollToTopOnRouteChange() {
  const location = useLocation();

  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
  }, [location.pathname]);

  return null;
}

/* ---------- Candidate Auth Guard ---------- */

function ProtectedCandidateRoute({ children }) {
  const token = localStorage.getItem("candidateToken");

  if (!token) return <Navigate to="/candidate" replace />;

  return children;
}

/* ---------- Test Access Guard ---------- */

function ProtectedTestRoute({ children, fallback = "/candidate/dashboard" }) {
  const [state, setState] = useState({ loading: true, allowed: false });

  useEffect(() => {
    let mounted = true;

    async function verify() {
      const token = localStorage.getItem("candidateToken");

      if (!token) {
        if (mounted) setState({ loading: false, allowed: false });
        return;
      }

      try {
        // ✅ FIXED: use api (no manual headers)
        const res = await api.get("/api/candidate/home");

        const student = res.data?.student || {};
        const paymentStatus = String(student.payment_status || "").toLowerCase();

        const allowed =
          paymentStatus.includes("paid") ||
          paymentStatus.includes("success") ||
          paymentStatus.includes("completed");

        if (mounted) setState({ loading: false, allowed });
      } catch (err) {
        console.error("Test access check failed:", err);
        if (mounted) setState({ loading: false, allowed: false });
      }
    }

    verify();

    return () => (mounted = false);
  }, []);

  if (state.loading) {
    return <div style={{ padding: 20 }}>Checking test access...</div>;
  }

  if (!state.allowed) {
    return <Navigate to={fallback} replace />;
  }

  return children;
}

/* ---------- Test Wrapper ---------- */

function TestWrapper() {
  const { id } = useParams();
  return <Test testId={id} />;
}

/* ---------- MAIN APP ---------- */

export default function App() {
  const [adminToken, setAdminToken] = useState(() =>
    localStorage.getItem("token")
  );

  const [candidateToken, setCandidateToken] = useState(() =>
    localStorage.getItem("candidateToken")
  );

  return (
    <BrowserRouter>
      <ScrollToTopOnRouteChange />

      <Navbar
        token={adminToken}
        onLogout={() => {
          localStorage.removeItem("token");
          setAdminToken(null);
          window.location.href = "/admin";
        }}
        onCandidateLogout={() => {
          localStorage.removeItem("candidateToken");
          setCandidateToken(null);
          window.location.href = "/candidate";
        }}
      />

      <main className="content">
        <Routes>

          {/* ---------- Public Routes ---------- */}

          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/fees" element={<Fees />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses/:id" element={<Courses />} />
          <Route path="/register" element={<Register />} />
          <Route path="/pay" element={<PayNow />} />

          {/* ---------- Candidate Login ---------- */}

          <Route
            path="/candidate"
            element={<CandidateLogin onCandidateLogin={setCandidateToken} />}
          />

          {/* ---------- Candidate Dashboard ---------- */}

          <Route
            path="/candidate/dashboard"
            element={
              <ProtectedCandidateRoute>
                <CandidateDashboard />
              </ProtectedCandidateRoute>
            }
          />

          {/* ---------- Candidate Test ---------- */}

          <Route
            path="/candidate/test"
            element={
              <ProtectedCandidateRoute>
                <ProtectedTestRoute>
                  <Test />
                </ProtectedTestRoute>
              </ProtectedCandidateRoute>
            }
          />

          <Route
            path="/test"
            element={
              <ProtectedCandidateRoute>
                <ProtectedTestRoute>
                  <Test />
                </ProtectedTestRoute>
              </ProtectedCandidateRoute>
            }
          />

          <Route
            path="/test/:id"
            element={
              <ProtectedCandidateRoute>
                <ProtectedTestRoute>
                  <TestWrapper />
                </ProtectedTestRoute>
              </ProtectedCandidateRoute>
            }
          />

          {/* ---------- Candidate Batches ---------- */}

          <Route
            path="/candidate/batches"
            element={
              <ProtectedCandidateRoute>
                <ProtectedTestRoute>
                  <CandidateBatches />
                </ProtectedTestRoute>
              </ProtectedCandidateRoute>
            }
          />

          {/* ---------- Admin ---------- */}

          <Route
            path="/admin"
            element={
              adminToken ? (
                <AdminDashboard token={adminToken} />
              ) : (
                <AdminLogin setToken={setAdminToken} />
              )
            }
          />

          {/* ---------- Password ---------- */}

          <Route path="/set-password" element={<SetPassword />} />

          {/* ---------- Fallback ---------- */}

          <Route path="*" element={<Navigate to="/" replace />} />

        </Routes>
      </main>

      <HelplineWidget />
      <Footer />
    </BrowserRouter>
  );
}